import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'ui/components/Dropdown';
import { startCase, toLower } from 'lodash';
export const DATEPICKER_YEARS = 2;

export default class YearMonthNav extends Component {
	static propTypes = {
		onChange: PropTypes.func.isRequired,
		localeUtils: PropTypes.object,
		locale: PropTypes.string,
		date: PropTypes.object,
	};

	static defaultProps = {
		date: new Date(),
		localeUtils: {},
		locale: 'en',
	};

	constructor(props) {
		super(props);

		this.months = this.createMonths();
		this.years = this.createYears();
	}

	months = [];
	years = [];

	createMonths() {
		return this.props.localeUtils
			.getMonths(this.props.locale)
			.map((m, i) => ({ text: startCase(toLower(m)), value: i }));
	}

	createYears() {
		const years = [];
		const currentYear = new Date().getFullYear();

		for (let i = currentYear; i > currentYear - DATEPICKER_YEARS; i -= 1) {
			years.push({ text: i, value: i });
		}

		return years;
	}

	handleChange(e) {
		const { year, month } = e.target.form;
		this.props.onChange(new Date(year.value, month.value));
	}

	handleMonthChange(value) {
		this.props.onChange(new Date(this.props.date.getFullYear(), value));
	}

	handleYearChange(value) {
		this.props.onChange(new Date(value, this.props.date.getMonth()));
	}

	render() {
		const { date } = this.props;
		const month = this.months.find(m => m.value === date.getMonth()).text;
		const year = date.getFullYear();

		return (
			<form className="DayPicker-Caption form-inline">
				<div className="form-group">
					<Dropdown
						title={month}
						items={this.months}
						onSelect={this.handleMonthChange.bind(this)}
					/>
				</div>
				<div className="form-group">
					<Dropdown
						caretClass="glyphicon glyphicon-triangle-bottom DayPicker-Caret"
						title={year}
						items={this.years}
						onSelect={this.handleYearChange.bind(this)}
					/>
				</div>
			</form>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/DatePicker/YearMonthNav.js